import { useCallback } from 'react';

import type { WaypointCallbackArgs } from 'src/app/shared/components/layout/lazy';
import { Waypoint } from 'src/app/shared/components/scroll';
import { useTrackOnce } from 'src/app/shared/hooks/tracking';

type ViewTrackingProps = Readonly<{
	card_petition_id: string;
	page_petition_id?: string;
	grid_position: number;
	petition_status: string;
	strategy?: string;
	algorithm: string;
}>;

type Props = Readonly<{
	petitionId: string;
	petitionStatus: string;
	parentPetitionId?: string;
	gridPosition: number;
	strategy?: string;
	algorithm: string;
}>;

export function PetitionCardViewTracker({
	petitionId,
	petitionStatus,
	parentPetitionId,
	gridPosition,
	strategy,
	algorithm,
}: Props): React.JSX.Element {
	const trackOnce = useTrackOnce();

	const onPositionChange = useCallback(
		({ currentPosition }: WaypointCallbackArgs) => {
			const trackingProperties: ViewTrackingProps = {
				card_petition_id: petitionId,
				page_petition_id: parentPetitionId,
				grid_position: gridPosition,
				petition_status: petitionStatus,
				strategy,
				algorithm,
			};

			if (currentPosition === 'below') {
				return;
			}
			void trackOnce('petition_card_view', trackingProperties);
		},
		[petitionId, parentPetitionId, gridPosition, petitionStatus, strategy, algorithm, trackOnce],
	);

	return <Waypoint onPositionChange={onPositionChange} />;
}
